<template>
  <div>
    <b-row>
      <b-col style="cursor: pointer" @click="$router.go(-1)" md="12" cols="12">
        <statistic-card-horizontal
          icon=""
          :statistic="$t('common.go-back')"
          class="modify"
        />
      </b-col>
      <b-col cols="12" sm="12">
        <b-card>
          <div class="d-flex justify-content-between">
            <h2 class="mb-2">
              {{ $t("reception.Main Patient Surgery Information") }}
            </h2>
            <div class="">
              <b-button
                v-if="
                  !updateSurgeryInfoIndicator &&
                  $store.state.app.permissions.includes('store-surgery')
                "
                @click="navigateWithDoctors()"
                variant="primary"
                class="p-1 mb-1"
                block
              >
                {{ $t("surgery.Add sub-surgery") }}
              </b-button>
              <!-- <b-button
                v-if="!updateSurgeryInfoIndicator"
                @click="show(EditForm, 'create', true)"
                variant="primary"
                class="p-1 mb-1"
                block
              >
                {{ $t('surgery.Add sub-surgery') }}
              </b-button> -->
              <b-button
                class="p-1 mb-1 w-100"
                variant="success"
                @click="printOperativeNotes()"
              >
                {{ $t("surgery.print-operative-notes") }}
              </b-button>
              <b-button
                v-if="!updateSurgeryInfoIndicator"
                @click="updateSurgeryInfo()"
                variant="warning"
                class="p-1 mb-1"
                block
              >
                {{ $t("surgery.Update Surgery Info") }}
              </b-button>
              <div v-else>
                <b-button
                  @click="updateSurgeryInfo()"
                  variant="warning"
                  class="p-1 mb-1"
                  block
                >
                  {{ $t("common.submit") }}
                </b-button>
                <b-button
                  @click="
                    updateSurgeryInfoIndicator = !updateSurgeryInfoIndicator
                  "
                  class="p-1 mb-1"
                  block
                >
                  {{ $t("common.cancel") }}
                </b-button>
              </div>
              <b-button
                variant="secondary"
                class="p-1 mb-1"
                block
                @click="generateAgreement()"
              >
                {{ $t("reception.print-agreement") }}
              </b-button>
              <b-button
                variant="warning"
                class="p-1 mb-1"
                block
                @click="changeSurgery()"
              >
                {{ $t("common.change-surgery") }}
              </b-button>
            </div>
          </div>
          <div v-if="!updateSurgeryInfoIndicator && patientSurgeryData">
            <div>
              <h5 class="my-2">
                <b>{{ $t("common.patient-name") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.patient_card.patient.name }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("common.patient-surgery") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.surgery.title }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("emergency.Patient Case") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.patient_case }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("emergency.Diagnosis") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.diagnosis }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("emergency.Investigation") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.investigation }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("emergency.Treatment") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.treatment }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("emergency.Examination") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.examination }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("surgery.procedure") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.procedure }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("common.final-result") }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.final_result }}
                </p>
              </h5>
              <!-- <h5 class="my-2">
                <b>{{ $t('surgery.surgery') }}:</b>
                <p class="mx-2 d-inline d-inline">
                  {{ patientSurgeryData.doctor_surgery.surgery_name }}
                </p>
              </h5> -->
              <!-- <h5 class="my-2">
                <b>{{ $t('surgery.Doctor') }}:</b>
                <p class="mx-2 d-inline">
                  {{ patientSurgeryData.doctor_surgery.doctor_name }}
                </p>
              </h5> -->
              <!-- <h5 class="my-2">
                <b>{{ $t('reception.Surgery Price') }}:</b>
                <p class="mx-2 d-inline">{{ patientSurgeryData.price }} IQD</p>
              </h5>

              <h5 class="my-2">
                <b>{{ $t('reception.Doctor Discount') }}:</b>
                <p class="mx-2 d-inline">
                  {{ patientSurgeryData.doctor_discount }} IQD
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t('reception.Surgery Discount') }}:</b>
                <p class="mx-2 d-inline">
                  {{ patientSurgeryData.surgery_discount }} IQD
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t('reception.Total Discount') }}:</b>
                <p class="mx-2 d-inline">
                  {{ patientSurgeryData.total_discount }}IQD
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t('reception.Total Price After Discount') }}:</b>
                <p class="mx-2 d-inline">
                  {{ patientSurgeryData.total_price_after_discount }}IQD
                </p>
              </h5>-->
            </div>

            <hr class="invoice-spacing" />
            <h2 class="my-2">{{ $t("surgery.Patient Surgery Updates") }}</h2>
            <div>
              <h5 class="my-2">
                <b>{{ $t("reception.patient-updates") }}:</b>
                <p
                  class="mx-2 d-inline"
                  style="unicode-bidi: isolate"
                  :style="{
                    direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
                  }"
                >
                  {{ patientSurgeryData.updated_at }}
                </p>
              </h5>
              <h5 class="my-2">
                <b>{{ $t("reception.patient-info-created-at") }}:</b>
                <p
                  class="mx-2 d-inline"
                  style="unicode-bidi: isolate"
                  :style="{
                    direction: $store.state.appConfig.isRTL ? 'rtl' : 'ltr',
                  }"
                >
                  {{ patientSurgeryData.created_at }}
                </p>
              </h5>
            </div>
          </div>
          <div v-else>
            <b-card-text>
              <b-row>
                <b-col md="12">
                  <div>
                    <b-form-group :label="$t('common.date')" label-for="Date">
                      <datepicker
                        v-model="updateSurgeryData.surgery_date_time"
                        :calendar-button="true"
                        :clear-button="true"
                        :bootstrap-styling="true"
                        style="height: 5rem"
                        class="datebtn2"
                        :placeholder="$t('common.date')"
                      ></datepicker>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col cols="6">
                  <b-form-group
                    :label="$t('surgery.patient_case')"
                    label-for="Case_Details"
                  >
                    <b-form-textarea
                      v-model="updateSurgeryData.patient_case"
                      :placeholder="$t('surgery.patient_case')"
                    />
                  </b-form-group>
                </b-col>

                <b-col cols="6">
                  <b-form-group :label="$t('surgery.diagnosis')">
                    <b-form-textarea
                      v-model="updateSurgeryData.diagnosis"
                      :placeholder="$t('surgery.diagnosis')"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group :label="$t('surgery.patient_case_details')">
                    <b-form-textarea
                      v-model="updateSurgeryData.patient_case_details"
                      :placeholder="$t('surgery.patient_case_details')"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    :label="$t('surgery.procedure')"
                    label-for="Case_Details"
                  >
                    <b-form-textarea
                      id="procedure"
                      v-model="updateSurgeryData.procedure"
                      :placeholder="$t('surgery.procedure')"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    :label="$t('common.filter-by-final-result')"
                    label-for="final_result"
                  >
                    <v-select
                      id="final_result"
                      v-model="updateSurgeryData.final_result"
                      :options="final_result_options"
                      :reduce="(option) => option.value"
                      :placeholder="$t('common.filter-by-final-result')"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-card-text>
          </div>
          <hr class="invoice-spacing my-4" />
          <div class="mx-2">
            <b-row>
              <b-col cols="12">
                <h2 class="my-2">{{ $t("surgery.surgery-doctor") }}</h2>
              </b-col>
              <b-col cols="12">
                <b-button
                  class="float-right"
                  variant="primary"
                  @click="openEditDoctorSurgeryModal()"
                >
                  {{ $t("common.edit") }}
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <b-table
                  :items="patientSurgeryData.doctors_prices.items"
                  responsive
                  :fields="doctor_surgery_fields"
                  primary-key="id"
                  show-empty
                  empty-text="No matching results found"
                  class="position-relative"
                >
                </b-table>
              </b-col>
            </b-row>
          </div>
          <div class="mx-2 mt-4">
            <b-row>
              <b-col cols="12">
                <h2 class="my-2">{{ $t("surgery.doctor-assistants") }}</h2>
              </b-col>
              <b-col cols="12">
                <b-button
                  class="float-right"
                  variant="primary"
                  @click="openEditDoctorAssistantsModal()"
                >
                  {{ $t("common.edit") }}
                </b-button>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col cols="12">
                <b-table
                  :items="patientSurgeryData.doctor_assist"
                  responsive
                  :fields="doctor_assist_fields"
                  primary-key="id"
                  show-empty
                  empty-text="No matching results found"
                  class="position-relative"
                >
                  <template #cell(type)="data">
                    {{
                      data.item.type == "surgeon_assistant"
                        ? $t("hospital.surgeon-assistant")
                        : $t("hospital.anesthetist-assistant")
                    }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </div>
          <hr class="invoice-spacing my-4" />
          <PatientSurgeryStaff
            :patientCardId="patientSurgeryData.patient_card.id"
            :doctorSurgeryId="patientSurgeryData.id"
            :staff="patientSurgeryData.surgery_staff"
            @getData="getPatientSurgeryInfo"
          />
          <hr class="invoice-spacing my-4" />
          <DoctorAssist
            :patientCardId="patientSurgeryData.patient_card.id"
            :doctorSurgeryId="patientSurgeryData.id"
            :doctorAssist="patientSurgeryData.doctor_assist"
            @getData="getPatientSurgeryInfo"
          />
          <hr class="invoice-spacing my-4" />
          <PatientSurgeyConsumables
            :patientCardId="patientSurgeryData.patient_card.id"
            :patientName="patientSurgeryData.patient_card.patient.name"
            :doctorSurgeryId="patientSurgeryData.id"
            @getData="getPatientSurgeryInfo"
          />
          <hr class="invoice-spacing my-4" />
          <Attachments
            attachableType="surgery"
            type="RADIOLOGY"
            :attachableId="patientSurgeryData.id"
          />
        </b-card>

        <SurgeryInvoice
          :patientSurgeryData="patientSurgeryData"
          :doctorSurgeryId="$route.params.id"
        />
      </b-col>
    </b-row>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfOpeartiveTable"
    >
      <section dir="ltr" class="pdf-content" slot="pdf-content">
        <section class="border border-dark font-modify m-5">
          <div
            class="border border-dark p-1"
            style="display: flex; justify-content: center"
          >
            <h3>Operative Notes</h3>
          </div>
          <div
            class="border border-dark p-1"
            style="display: flex; justify-content: space-between"
          >
            <span>
              <p class="px-1" style="background-color: white">
                Name: {{ patientSurgeryData.patient_card.patient.name }}
              </p>
            </span>
            <span>
              <p class="px-4">
                Age:{{ patientSurgeryData.patient_card.patient.birth_date }}
              </p>
            </span>
          </div>

          <table style="width: 100%; table-layout: fixed">
            <tr style="height: 60px">
              <th class="px-1" style="text-align: left">
                <!-- Surgon :{{ patientSurgeryData.doctor_surgery.doctor_name }} -->
              </th>
              <th
                class="px-1"
                style="text-align: left"
                v-if="
                  patientSurgeryData.surgery_staff.length &&
                  patientSurgeryData.surgery_staff[0].employee
                "
              >
                Anaesthetist :{{
                  patientSurgeryData.surgery_staff[0].employee.full_name
                }}
              </th>

              <th
                class="px-1"
                style="text-align: left"
                v-if="
                  patientSurgeryData.surgery_staff.length &&
                  patientSurgeryData.surgery_staff[0].employee
                "
              >
                Nurse :
                {{ patientSurgeryData.surgery_staff[0].employee.full_name }}
              </th>
            </tr>
            <tr class="px-1" style="height: 60px">
              <th
                class="px-1"
                style="text-align: left"
                v-if="patientSurgeryData.doctor_assist.length"
              >
                Assiatant : {{ patientSurgeryData.doctor_assist[0].name }}
              </th>
              <th class="px-1" style="text-align: left">Anaesthetsia:</th>

              <th class="px-1" style="text-align: left"></th>
            </tr>
          </table>
        </section>
        <div class="font-modify mt-1 mx-5">
          <h4>Procedure :- {{ patientSurgeryData.procedure }}</h4>
        </div>
      </section>
    </vue-html2pdf>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="patient card"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="800px"
      @hasStartedGeneration="hasStartedGeneration()"
      @hasGenerated="hasGenerated($event)"
      ref="html2PdfAgreement"
    >
      <section
        dir="ltr"
        style="font-size: 18px"
        class="pdf-content font-modify m-5"
        slot="pdf-content"
      >
        <h1 class="text-center text-dark mb-2">مستشفى الوزيرية</h1>
        <h4 class="text-center text-dark">
          اقرار خطي بموافقة المريض<br />
          على اجراء التدخلات والفحوصات الطبية
        </h4>
        <div class="mx-2 text-dark mt-2">
          <p dir="rtl" style="background-color: white; line-height: 2">
            اني المريض
            <span
              style="text-decoration: underline; text-decoration-style: dotted"
            >
              {{ patientSurgeryData.patient_card.patient.name }}</span
            >
            الموقع ادناه والراقد في مستشفى الوزيرية الاهلي، اطلعني الطبيب
            <!-- المعالج <span style="text-decoration: underline"> {{ patientSurgeryData.doctor_surgery.doctor_name }}</span> على -->
            طبيعة مرضي وعلى طبيعة التدخلات الطبية كافة (العلاجية والجراحية)
            اللازمة لعلاجي من مرضي وبضمنها المخاطر والمضاعفات التي قد تنجم عن
            تلك التدخلات او الفحوصات واوافق على اجراء تلك الفحوصات والتدخلات كما
            اوافق على اجراء عملية
            <!-- <span style="text-decoration: underline">              {{ patientSurgeryData.doctor_surgery.surgery_name }}</span -->
            واعطائي التخدير من قبل طبيب التخدير
            <span
              style="text-decoration: underline"
              v-if="
                patientSurgeryData.surgery_staff.length &&
                patientSurgeryData.surgery_staff[0].employee
              "
            >
              {{ patientSurgeryData.surgery_staff[0].employee.full_name }}</span
            >
            وبالطريقة التي يرتأيها مناسبة لحالتي وكما اخول الطبيب المعالج طلب
            المساعدة او استشارة طبيب اخر عند الضرورة ويعتبر هذا اقرار شامل اوقعة
            بارادتي وبكامل حريتي وذلك بتاريخ. وفي حالة تعذر قيام المريض على
            التوقيع لكونه قاصراً او متخلفاً عقلياً او فاقد للوعي او في حالة
            طارئة لايمكنه التوقيع يقوم احد افراد اسرته بالتوقيع نيابة عنه (على
            ان يكون من اقارب من الدرجة الاولى). يستثنى من ذلك تعرض حياة المريض
            للخطر او الموت عند تأخر اجرائها فيجوز عندئذ اجراء ما تتطلبه حالة
            المريض دون تحقق الموافقة المذكورة استناداً لقانون الصحة العامة رقم
            89 لسنة 1981 الباب الرابع الفرع الاول المادة 91 الفقرة (ب). في حال
            حدوث اي نزاع بين الطرفين تكون وزارة الصحة هي المرجع في حل هذا النزاع
            استناداً الى قانون رقم (26 لسنة 2013 المادة 1-اولاً والمادة 5)
            واتنازل عن حقي بمطالبة المستشفى او اي من الكادر العامل فيها بمطالبة
            عشائرية او دينية نتيجة اي ضرر مادي او معنوي.
          </p>
          <div class="my-5 d-flex justify-content-between mx-4">
            <section>
              <p>المريض او ذويه</p>
            </section>
            <section>
              <p>مسؤول الردهة</p>
            </section>
          </div>
          <hr class="dotted mx-4 text-dark border-dark border-2" />
          <p dir="rtl" style="background-color: white; line-height: 2">
            اني المريض
            <span style="text-decoration: underline">
              {{ patientSurgeryData.patient_card.patient.name }}</span
            >
            اصر على الخروج من المستشفى رغم نصح الاطباء وكادر المستشفى وبذلهم كل
            المحاولات لاقناعي بالبقاء في المستشفى وحسب ما تقتضيه حالتي الصحية
            اخلي المسؤولية الاطباء والمستشفى من المضاعافات الناجمة عن خروجي من
            المستشفى وذلك بتاريخ (تعليمات وزارة الصحة كتاب رقم 10700 في
            2008/8/17).
          </p>
          <div class="my-5 d-flex justify-content-between mx-4">
            <section>
              <p>المريض او ذويه</p>
            </section>
            <section>
              <p>مسؤول الردهة</p>
            </section>
          </div>
        </div>
      </section>
    </vue-html2pdf>

    <b-modal
      id="modal-edit-doctor-surgery"
      :title="$t('accounting.edit-doctor-surgery')"
      ok-only
      centered
      size="lg"
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <b-row>
          <b-col md="12" cols="12" class="mt-3">
            <b-form-group label="Doctors">
              <v-select
                v-model="selectedDoctors"
                :options="doctors"
                multiple
                label="name"
                :reduce="(doctor) => doctor"
                :close-on-select="false"
              >
                <template #option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-primary">
                      ({{
                        type == "surgeon"
                          ? $t("hospital.surgeon")
                          : $t("hospital.anesthetist")
                      }})
                    </span>
                  </b>
                </template>
                <template #selected-option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-success">
                      ({{
                        type == "surgeon"
                          ? $t("hospital.surgeon")
                          : $t("hospital.anesthetist")
                      }})
                    </span>
                  </b>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- <b-col md="12" cols="12" class="mb-2">
            <div
              v-if="selectedDoctors.length > 0"
              class="d-flex justify-content-center flex-wrap"
            >
              <div
                v-for="doctor in selectedDoctors"
                :key="doctor.id"
                class="doctor-card"
              >
                <p class="mb-0">
                  {{ doctor.name }}
                </p>
                <div class="role-selection">
                  <b-form-checkbox
                    v-model="doctor.type"
                    :value="'surgeon'"
                    :unchecked-value="'anesthetist'"
                    class="role-checkbox"
                    switch
                    default-value="surgeon"
                  >
                    {{ doctor.type }}
                  </b-form-checkbox>
                </div>
              </div>
            </div>
          </b-col> -->
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitEditDoctorSurgery"
          class="m-0"
          :disabled="loadingEditDoctorSurgery"
          block
        >
          <span v-if="!loadingEditDoctorSurgery">
            {{ $t("common.save") }}
          </span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-edit-doctor-assistants"
      :title="$t('accounting.edit-doctor-assistants')"
      ok-only
      centered
      size="lg"
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <b-row>
          <b-col md="12" cols="12" class="mt-3">
            <b-form-group label="Doctors">
              <v-select
                v-model="selectedDoctorAssistants"
                :options="doctorAssistants"
                multiple
                :close-on-select="false"
              >
                <template #option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-primary">
                      ({{
                        type == "surgeon_assistant"
                          ? $t("hospital.surgeon-assistant")
                          : $t("hospital.anesthetist-assistant")
                      }})
                    </span>
                  </b>
                </template>
                <template #selected-option="{ name, type }">
                  <b style="margin: 0">
                    {{ name }}
                    <span class="text-success">
                      ({{
                        type == "surgeon_assistant"
                          ? $t("hospital.surgeon-assistant")
                          : $t("hospital.anesthetist-assistant")
                      }})
                    </span>
                  </b>
                </template>
              </v-select>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitEditDoctorAssistants"
          class="m-0"
          :disabled="loadingEditDoctorAssistants"
          block
        >
          <span v-if="!loadingEditDoctorAssistants">
            {{ $t("common.save") }}
          </span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      id="modal-change-surgery"
      :title="$t('surgery.change-surgery')"
      ok-only
      centered
      size="lg"
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <b-row>
          <b-col md="12" cols="12" class="mt-3">
            <b-form-group :label="$t('surgery.surgery')">
              <v-select
                v-model="selectedSurgery"
                :options="availableSurgeriesOptions"
                :placeholder="$t('surgery.choose-surgery')"
                label="title"
                :reduce="(option) => option.id"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-text>
      <template #modal-footer="{}">
        <b-button
          variant="primary"
          @click="submitChangeSurgery"
          class="m-0"
          :disabled="loadingChangeSurgery"
          block
        >
          <span v-if="!loadingChangeSurgery">{{ $t("common.save") }}</span>
          <b-spinner small v-else></b-spinner>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import {
  BCard,
  BRow,
  BCol,
  BButton,
  BLink,
  BCardText,
  BFormGroup,
  BFormTextarea,
  BFormInput,
  BTable,
  BSpinner,
  BFormCheckbox,
} from "bootstrap-vue";

import ReceptionHistoryCard from "@/components/reception/ReceptionHistoryCard";
import ReceptionPatientCardWithQR from "@/components/reception/ReceptionPatientCardWithQR";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
const AutoComplete = () => import("@/components/common/AutoComplete.vue");
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import PatientRoom from "@/views/rooms/PatientRoom.vue";
import DoctorAssist from "@/views/surgery/DoctorAssist.vue";
import PatientSurgeryStaff from "@/views/surgery/PatientSurgeryStaff.vue";
import PatientSurgeryInvoice from "@/views/surgery/SurgeryInvoice.vue";
import Datepicker from "vuejs-datepicker";
import { async } from "vue-phone-number-input/dist/vue-phone-number-input.common";
import ActionsButtons from "@/components/common/ActionsButtons.vue";
import DeleteModal from "@/components/modals/DeleteModal.vue";
const SurgeryInvoice = () => import("@/views/surgery/SurgeryInvoice.vue");
import VueHtml2pdf from "vue-html2pdf";

import PatientSurgeyConsumables from "@/views/surgery/PatientSurgeyConsumables.vue";
import Attachments from "@/components/common/Attachments.vue";

export default {
  components: {
    Datepicker,
    BRow,
    BTable,
    BCol,
    BLink,
    BFormInput,
    BFormGroup,
    BCard,
    BCardText,
    BButton,
    ReceptionHistoryCard,
    ReceptionPatientCardWithQR,
    StatisticCardHorizontal,
    AutoComplete,
    vSelect,
    ToastificationContent,
    PatientRoom,
    DoctorAssist,
    PatientSurgeryStaff,
    ActionsButtons,
    PatientSurgeryInvoice,
    DeleteModal,
    VueHtml2pdf,
    BFormTextarea,
    SurgeryInvoice,
    PatientSurgeyConsumables,
    Attachments,
    BSpinner,
    BFormCheckbox,
  },
  data() {
    return {
      params: {
        form: {},
        path: "",
      },
      EditForm: {
        patient_card_id: this.$route.params.id,
        doctor_surgery_id: "",
        // price: this.finalPrice,
        price: "",
        surgery_date_time: "",

        surgery_discount: 0,
        doctor_discount: 0,
        _method: "POST",
        sub_surgery_id: this.patientSurgeryData?.doctor_surgery.surgery_id,
      },
      updateSurgeryData: {
        surgery_date_time: "",
        patient_case: "",
        patient_case_details: "",
        diagnosis: "",
        procedure: "",
        final_result: "",
        _method: "PUT",
      },

      patientSurgeryData: {},
      patientTest: {},
      patientTestForm: {
        patient_card_id: "",
        tests: [],
        _method: "PUT",
      },
      errorForm: {
        patient_card_id: "",
        doctor_surgery_id: "",
        price: "",
        surgery_date_time: "",
        surgery_discount: 0,
        doctor_discount: 0,
      },
      take: 10,
      loading: true,
      typeList: [
        {
          text: "Type 1",
          value: "0",
        },
        {
          text: "Type 2",
          value: "1",
        },
      ],
      staffCreateMode: "",
      staffForm: {
        patient_card_doctor_surgery_id: "",
        employee_id: "",
        anesthetist_type: "",
        price: "",
        _method: "PUT",
      },
      patientRadiology: {},
      patientRadiologyForm: {
        type: "",
        url: "",
        patient_card_id: "",
        radiology_id: "",
        _method: "PUT",
      },
      surgeryId: null,
      surgery: {},
      doctorSurgery: null,
      tableColumns: [
        {
          key: "name",
          label: this.$t("common.Full Name"),
          sortable: true,
        },
        {
          key: "price",
          label: this.$t("common.price"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      staffTableColumns: [
        {
          key: "employee_id",
          label: this.$t("common.Full Name"),
          sortable: true,
        },
        {
          key: "anesthetist_type",
          label: this.$t("common.type"),
          sortable: true,
        },
        {
          key: "price",
          label: this.$t("common.price"),
          sortable: true,
        },
        { key: "Actions", label: this.$t("common.actions") },
      ],
      doctor_surgery_fields: [
        { key: "doctor.name", label: this.$t("surgery.doctor-name") },
        { key: "type", label: this.$t("surgery.doctor-type") },
        { key: "doctor.phone", label: this.$t("surgery.phone") },
        { key: "created_at", label: this.$t("surgery.created-at") },
      ],
      doctor_assist_fields: [
        { key: "name", label: this.$t("surgery.doctor-name") },
        { key: "type", label: this.$t("surgery.doctor-type") },
        { key: "phone", label: this.$t("surgery.phone") },
        { key: "created_at", label: this.$t("surgery.created-at") },
      ],
      updateSurgeryInfoIndicator: false,
      updateSubSurgeryInfoIndicator: false,
      doctorAssist: {
        patient_card_doctor_surgery_id: "",
        name: "",
        price: "",
        _method: "PUT",
      },
      updateDoctorSurgery: null,
      doctorSurgeryData: [],
      loadingEditDoctorSurgery: false,
      loadingOpenEditDoctorSurgeryModal: false,
      doctors: [],
      selectedDoctors: [],
      final_result: null,
      final_result_options: [
        { label: this.$t("common.success-operation"), value: "success" },
        { label: this.$t("common.failed-operation"), value: "failed" },
      ],
      doctorAssistants: [],
      selectedDoctorAssistants: [],
      selectedSurgery: null,
      availableSurgeriesOptions: [],
      loadingChangeSurgery: false,
      tempSurgery: null,
    };
  },
  mounted() {
    this.getPatientSurgeryInfo();
    this.getPatientCard();
  },

  watch: {
    surgeryId(newSurgeryId) {
      // Check if surgeryId is not null or undefined
      if (newSurgeryId != null) {
        // Call the method to get surgery details
        this.getSurgeryList();
      } else {
        this.updateSurgeryData.price = "";
      }

      if (newSurgeryId != this.patientSurgeryData.doctor_surgery.surgery_id) {
        this.doctorSurgery = "";
      }
    },
    doctorSurgery() {
      // this.EditForm.price = this.EditForm.price + this.doctorSurgery.price;
    },
  },
  computed: {
    finalPrice() {
      return this.surgery.price + this.doctorSurgery.price;
    },
  },
  methods: {
    async getDoctorAssistants() {
      try {
        const response = await this.getList("/doctorAssistants");
        this.doctorAssistants = response.data.data;
      } catch (error) {
        console.error("Error fetching doctor assistants:", error);
      }
    },
    async getDoctors() {
      await this.getList("doctor?take=100").then((response) => {
        this.doctors = response.data.data.map((doctor) => ({
          id: doctor.id,
          name: doctor.name,
          type: doctor.type,
        }));
      });
    },
    // edit doctor surgery
    async openEditDoctorSurgeryModal(item) {
      this.loadingOpenEditDoctorSurgeryModal = true;
      this.tempSurgery = this.patientSurgeryData;
      console.log("tempSurgery", this.tempSurgery);
      item = this.patientSurgeryData;
      this.selectedDoctors = item.doctors_prices.items.map((doctor) => ({
        id: doctor.doctor_id,
        name: doctor.doctor.name,
        type: doctor.type
      }));

      await this.getDoctors();
      this.loadingOpenEditDoctorSurgeryModal = false;
      this.$bvModal.show(`modal-edit-doctor-surgery`);
    },
    // edit doctor assistants
    async openEditDoctorAssistantsModal(item) {
      this.loadingOpenEditDoctorAssistantsModal = true;
      this.tempSurgery = this.patientSurgeryData;

      item = this.patientSurgeryData;
      this.selectedDoctorAssistants = item.doctor_assist.map((doctor) => ({
        id: doctor.id,
        name: doctor.name,
        type: doctor.type,
      }));

      await this.getDoctorAssistants();
      this.loadingOpenEditDoctorAssistantsModal = false;
      this.$bvModal.show(`modal-edit-doctor-assistants`);
    },

    async submitEditDoctorSurgery() {
      console.log("surgeryPrice", this.doctorSurgeryData);
      this.loadingEditDoctorSurgery = true;

      this.params.form = {
        surgery_id: this.tempSurgery.surgery_id,
        doctors: this.selectedDoctors.map((doctor) => ({
          id: doctor.id,
          type: doctor.type,
        })),
        _method: "PUT",
      };

      // Use the id of the current surgery record for the endpoint
      this.params.path = `/patient-surgery/${this.$route.params.id}`;

      try {
        await this.$store.dispatch("put", this.params);
        this.loadingEditDoctorSurgery = false;
        this.$bvModal.hide("modal-edit-doctor-surgery");
        this.getPatientSurgeryInfo();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            variant: "success",
            text: "Doctor surgery updated successfully",
          },
        });
      } catch (error) {
        this.loadingEditDoctorSurgery = false;
        if (error.response && error.response.status === 400) {
          Object.keys(error.response.data).forEach((item) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          });
        }
      }
    },
    async submitEditDoctorAssistants() {
      console.log("doctorAssistants", this.selectedDoctorAssistants);
      this.loadingEditDoctorAssistants = true;

      this.params.form = {
        surgery_id: this.tempSurgery.surgery_id,
        doctor_assist: this.selectedDoctorAssistants.map((doctor) => ({
          id: doctor.id,
          type: doctor.type,
        })),
        _method: "PUT",
      };

      // Use the id of the current surgery record for the endpoint
      this.params.path = `/patient-surgery/${this.$route.params.id}`;

      try {
        await this.$store.dispatch("put", this.params);
        this.loadingEditDoctorAssistants = false;
        this.$bvModal.hide("modal-edit-doctor-assistants");
        this.getPatientSurgeryInfo();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            variant: "success",
            text: "Doctor assistants updated successfully",
          },
        });
      } catch (error) {
        this.loadingEditDoctorAssistants = false;
        if (error.response && error.response.status === 400) {
          Object.keys(error.response.data).forEach((item) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          });
        }
      }
    },
    navigateWithDoctors(isSub) {
      this.$store.dispatch("updateDoctors", this.patientSurgeryData.doctors);

      // Navigate to the new route
      this.$router.push({
        name: "add-patient-surgery",
        params: {
          id: this.patientSurgeryData.patient_card.id,
          isSub: true,
        },
        query: {
          patientId: this.patientSurgeryData.patient_card.patient.id,
          isSub: true,
          surgeryId: this.patientSurgeryData.id,
        },
      });
    },
    deleteModel(item, mode) {
      if (mode === "doctor_assist") {
        this.deleteForm = item;
        this.$bvModal.show("modal-doctor-assist-delete");
      } else {
        this.deleteForm = item;
        this.$bvModal.show("modal-staff-delete");
      }
    },
    printOperativeNotes() {
      this.$refs.html2PdfOpeartiveTable.generatePdf();
    },
    show(item, mode) {
      if (mode === "doctor-assist") {
        if (mode === true) {
          this.doctorAssist.id = item.id;
          this.doctorAssist.patient_card_doctor_surgery_id =
            this.doctorSurgeryId;
          this.doctorAssist.name = item.name;
          this.doctorAssist.price = item.price;
          this.doctorAssist._method = "PUT";

          this.$bvModal.show("modal-doctor-assist-edit");
        }
      } else {
        if (mode === false) {
          this.staffCreateMode = false;

          this.staffForm.id = item.id;
          this.staffForm.patient_card_doctor_surgery_id = this.doctorSurgeryId;
          this.staffForm.employee_id = item.employee_id;
          this.staffForm.price = item.price;
          this.staffForm.anesthetist_type = item.anesthetist_type;
          this.staffForm._method = "PUT";
          this.$bvModal.show("modal-staff-edit");
        } else {
          this.surgeryId = null;
          this.staffCreateMode = true;
          this.staffForm = {
            patient_card_doctor_surgery_id: this.doctorSurgeryId,
            employee_id: "",
            anesthetist_type: "",
            price: "",
            _method: "POST",
          };
        }
      }
    },

    async getSurgeryList() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/surgery?filter[id]=${this.surgeryId}`;

      await this.getList(url);
      this.surgery = this.all_data.data[0];
      if (this.surgery) {
        this.updateSurgeryData.price = this.surgery.price;
      }

      this.loading = false;
    },
    updateSurgeryInfo() {
      if (!this.updateSurgeryInfoIndicator) {
        this.updateSurgeryInfoIndicator = true;
        this.surgeryId = this.patientSurgeryData.doctor_surgery.surgery_id;
        this.doctorSurgery = this.patientSurgeryData.doctor_surgery.id;
        this.updateSurgeryData.price = this.patientSurgeryData.price;
        this.updateSurgeryData.patient_card_id =
          this.patientSurgeryData.patient_card_id;
        this.updateSurgeryData.surgery_date_time = this.formatDate(
          this.patientSurgeryData.surgery_date_time
        );
        this.updateSurgeryData.surgery_discount =
          this.patientSurgeryData.surgery_discount;
        this.updateSurgeryData.doctor_discount =
          this.patientSurgeryData.doctor_discount;
        this.updateSurgeryData.final_result =
          this.patientSurgeryData.final_result;
      } else {
        this.updateSurgeryData.surgery_date_time = this.formatDate(
          this.updateSurgeryData.surgery_date_time
        );

        this.updateSurgeryData.patient_card_id =
          this.patientSurgeryData.patient_card_id;
        this.updateSurgeryData.surgeryId = this.surgeryId;
        this.params.path = `/patient-surgery/${this.patientSurgeryData.id}`;
        this.params.form = this.updateSurgeryData;
        this.$store
          .dispatch("update", this.params)
          .then(async (response) => {
            this.updateSurgeryInfoIndicator = false;
            this.getPatientSurgeryInfo();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Card Stopped",
                variant: "success",
                text: error.response.data[item][0],
              },
            });
            await this.getPatientSurgeryInfo();
            this.updateSurgeryInfoIndicator = false;
          })
          .catch((error) => {
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
      }
    },
    updateSubSurgeryInfo() {
      console.log(this.patientSurgeryData);

      if (!this.updateSubSurgeryInfoIndicator) {
        this.updateSubSurgeryInfoIndicator = true;
        this.surgeryId =
          this.patientSurgeryData.sub_surgeries[0].doctor_surgery.surgery_id;
        this.doctorSurgery =
          this.patientSurgeryData.sub_surgeries[0].doctor_surgery.id;
        this.updateSurgeryData.price =
          this.patientSurgeryData.sub_surgeries[0].price;
        this.updateSurgeryData.patient_card_id =
          this.patientSurgeryData.patient_card_id;
        this.updateSurgeryData.surgery_date_time = this.formatDate(
          this.patientSurgeryData.sub_surgeries[0].surgery_date_time
        );
        this.updateSurgeryData.surgery_discount =
          this.patientSurgeryData.sub_surgeries[0].surgery_discount;
        this.updateSurgeryData.doctor_discount =
          this.patientSurgeryData.sub_surgeries[0].doctor_discount;
      } else {
        this.updateSurgeryData.surgery_date_time = this.formatDate(
          this.patientSurgeryData.sub_surgeries[0].surgery_date_time
        );
        this.updateSurgeryData.patient_card_id =
          this.patientSurgeryData.patient_card_id;
        this.updateSurgeryData.doctor_surgery_id = this.doctorSurgery;
        this.updateSurgeryData.surgeryId = this.surgeryId;
        this.params.path = `/patient-surgery/${this.patientSurgeryData.sub_surgeries[0].id}`;
        this.params.form = this.updateSurgeryData;
        this.$store
          .dispatch("update", this.params)
          .then(async (response) => {
            this.updateSubSurgeryInfoIndicator = false;

            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Card Stopped",
                variant: "success",
                text: error.response.data[item][0],
              },
            });
            await this.getPatientSurgeryInfo();
            this.updateSurgeryInfoIndicator = false;
          })
          .catch((error) => {
            console.log(error);
            if (error.response.status === 400) {
              for (let item in error.response.data) {
                this.$toast({
                  component: ToastificationContent,
                  position: "top-right",
                  props: {
                    title: "validation error",
                    variant: "danger",
                    text: error.response.data[item][0],
                  },
                });
              }
            }
          });
      }
    },
    formatDate(date) {
      const newDate = new Date(date);
      const year = newDate.getFullYear();
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const day = String(newDate.getDate()).padStart(2, "0");
      const hours = String(newDate.getHours()).padStart(2, "0");
      const minutes = String(newDate.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
    submitItem() {
      for (let item in this.errorForm) {
        this.errorForm[item] = "";
        if (this.EditForm[item] == "" || this.EditForm[item] == null)
          delete this.EditForm[item];
      }

      this.EditForm.surgery_date_time = this.formatDate(
        this.EditForm.surgery_date_time
      );

      // this.EditForm.price = this.EditForm.price;
      this.EditForm.patient_card_id = this.patientSurgeryData.patient_card.id;
      if (this.createMode) {
        (this.params.form = this.EditForm),
          (this.params.path = `/patient-surgery`),
          this.$store
            .dispatch("create", this.params)
            .then((response) => {
              this.getPatientSurgeryInfo();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      } else {
        (this.params.form = this.EditForm),
          (this.params.path = `/patient-surgery/${this.EditForm.id}`),
          this.$store
            .dispatch("update", this.params)
            .then((response) => {
              this.getPatientsSurgeries();
            })
            .catch((error) => {
              if (error.response.status === 400) {
                for (let item in error.response.data) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "validation error",
                      variant: "danger",
                      text: error.response.data[item][0],
                    },
                  });
                }
              }
            });
      }
    },

    async getPatientCard() {
      this.loading = true;
      await this.getPatient(
        `patientCard?filter[id]=${this.$route.params.id}&include=patient`
      );
      this.loading = false;
      for (let item in this.all_data) {
        if (this.all_data[item] == null) this.all_data[item] = "";
      }
      this.patientCardData = this.all_data.data[0];
    },
    async getPatientsSurgeries() {
      this.loading = true;
      // check if there are any null value in the obj we sending

      let url = `/patient-surgery?filter[patient_card_id]=${this.patientCardId}&page=${this.page}&take=${this.take}&sort=-id&include=doctorSurgery,patientCard`;

      if (this.doctorSurgeryFilter) {
        url += `&filter[doctor_surgery_id]=${this.doctorSurgeryFilter}`;
      }
      if (this.PatientCardFilter) {
        url += `&filter[patient_card_id]=${this.PatientCardFilter}`;
      }
      if (this.priceFilter) {
        url += `&filter[price]=${this.priceFilter}`;
      }

      await this.getList(url);
      this.dataCount = this.all_data.total;
      this.data = this.all_data.data;
      this.loading = false;
    },
    show(item, mode) {
      if (mode === "create") {
        this.surgeryId = null;
        this.createMode = true;
        this.EditForm = {
          patient_card_id: this.patientCardId,
          doctor_surgery_id: "",
          price: "",
          surgery_date_time: "",
          surgery_discount: "",
          doctor_discount: "",
          _method: "POST",
        };
      } else {
        this.createMode = false;
        this.EditForm.id = item.id;
        this.EditForm.patient_card_id = this.patientCardId;
        this.EditForm.doctor_surgery_id = item.doctor_surgery_id;
        // this.EditForm.price = item.price;
        this.EditForm.surgery_date_time = item.surgery_date_time;
        this.EditForm.surgery_discount = item.surgery_discount;
        this.EditForm.doctor_discount = item.doctor_discount;
        this.EditForm.surgery_date_time = item.surgery_date_time;
        this.EditForm._method = "PUT";
      }
      this.$bvModal.show("modal-surgery-edit");
    },

    generateAgreement() {
      this.$refs.html2PdfAgreement.generatePdf();
    },
    async getPatientSurgeryInfo() {
      this.loading = true;

      await this.getList(
        `patient-surgery/${this.$route.params.id}?include=doctorAssist,surgeryStaff,patientCard,doctors`
      );

      this.loading = false;

      this.patientSurgeryData = this.all_data;
    },
    formatDate(date) {
      if (date instanceof Date) {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, "0"); // JavaScript months are 0-based
        const day = date.getDate().toString().padStart(2, "0");
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}`;
      } else {
        console.log("date is not an instance of Date.");
      }
    },
    async submitChangeSurgery() {
      this.loadingChangeSurgery = true;

      this.params.form = {
        surgery_id: this.selectedSurgery,
        _method: "PUT",
      };

      // Use the id of the current surgery record for the endpoint
      this.params.path = `/patient-surgery/${this.$route.params.id}`;

      try {
        await this.$store.dispatch("put", this.params);
        this.loadingChangeSurgery = false;
        this.$bvModal.hide("modal-change-surgery");
        this.getPatientSurgeryInfo();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Success",
            variant: "success",
            text: "Surgery changed successfully",
          },
        });
      } catch (error) {
        this.loadingChangeSurgery = false;
        if (error.response && error.response.status === 400) {
          Object.keys(error.response.data).forEach((item) => {
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "Validation Error",
                variant: "danger",
                text: error.response.data[item][0],
              },
            });
          });
        }
      }
    },
    async changeSurgery() {
      // Get available surgeries
      await this.getList("surgery?take=100");
      this.availableSurgeriesOptions = this.all_data.data.map(surgery => ({
        id: surgery.id,
        title: surgery.title
      }));
      
      // Show the modal
      this.$bvModal.show("modal-change-surgery");
    },
  },
};
</script>

<style scoped>
.mb-md-0 {
  margin-top: 8px;
}

table {
  width: 94%;
  border: 1px solid;
  font-size: 11px;
}

.no-border {
  border: 0;
}

.square-dark {
  background-color: rgba(0, 0, 0, 0.2);
}

tr,
th,
td {
  border: 1px solid;
  width: 10px;
  height: 10px;
  text-align: center;
}

.font-modify {
  letter-spacing: normal !important;
}

.pdf-table {
  page-break-inside: avoid;
}

.square {
  width: 30px;
  /* Smaller width for squares */
  height: 30px;
  /* Smaller height for squares */
  background-color: #000;
  /* Color of the square */
  display: inline-block;
  /* Allows us to set width and height */
}

.centered-text {
  text-align: center;
  border: 2px solid #000;
  /* Border for the cell */
}

#table-above {
  border-collapse: collapse;
  /* Removes space between borders */
  font-size: 12px;
  /* Smaller font size for the entire table */
}

@media print {
  @page {
  }

  .pdf-table {
    page-break-before: avoid;
    page-break-inside: avoid;
  }
}

.pdf-table:first-child {
  margin-top: 1em;
  /* Adjust the value as needed */
  page-break-inside: avoid;
}

.doctor-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 10px;
  margin: 5px;
  background-color: #f9f9f9;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 200px;
  text-align: center;
}

.role-selection {
  margin-top: 10px;
}

.role-checkbox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.role-checkbox >>> .custom-control-label {
  font-size: 14px;
  color: #333;
}

.role-checkbox
  >>> .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #007bff;
  border-color: #007bff;
}

.role-checkbox >>> .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
</style>
